import { render, staticRenderFns } from "./ClientesExtraCostosPage.vue?vue&type=template&id=436e2f36"
import script from "./ClientesExtraCostosPage.vue?vue&type=script&lang=js"
export * from "./ClientesExtraCostosPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports